export const GET_CATEGORY = "GET_CATEGORY";
export const LOADING = "LOADING";
export const LOADED = "LOADED";
export const APP_STATUS = "APP_STATUS";
export const CHANGE_DHELIMIT = "CHANGE_DHELIMIT";
export const CHANGE_OHELIMIT = "CHANGE_OHELIMIT";
export const GET_CATEGORY_TYPES = "GET_CATEGORY_TYPES";
export const GET_GROCERY_CATEGORY = "GET_GROCERY_CATEGORY";
export const GET_MEAT_CATEGORY = "GET_MEAT_CATEGORY";
